import { Injectable } from '@angular/core';
import { CellClassParams, ColDef, ColumnWidthCallbackParams, ExcelExportParams, ExcelStyle } from '@ag-grid-community/core';
import { Destroyable } from '@frontend-site/shared/utils';
import { scopedBusySignal } from '@frontend-site/shared/core';

@Injectable({
    providedIn: 'root'
})
export class ExcelExporterService extends Destroyable {
    private readonly busySubject = scopedBusySignal(this);

    public excelStyles: ExcelStyle[] = [
        {
            id: 'header',
            interior: {
                color: '#777777',
                pattern: 'Solid',
                patternColor: ''
            },
            font: {
                size: 12,
                color: '#ffffff'
            }
        },
        {
            id: 'groupCell',
            font: {
                size: 12,
                bold: true
            },
            dataType: 'String'
        },
        {
            id: 'cell',
            font: {
                size: 12
            },
            dataType: 'String',
            alignment: {
                wrapText: true
            }
        },
        {
            id: 'templateSection',
            interior: {
                color: '#C5D9F1',
                pattern: 'Solid',
                patternColor: ''
            },
            font: {
                size: 16,
                bold: true
            },
            borders: {
                borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1 },
                borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1 },
                borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1 },
                borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1 }
            },
            dataType: 'String'
        },
        {
            id: 'linkableRendererClass',
            font: {
                underline: 'Single',
                color: '#358ccb'
            }
        }
    ];

    public getGroupCellClass({ node }: CellClassParams): string {
        let cellClassName = '';
        if (node?.group) {
            cellClassName = 'groupCell';
        }
        return cellClassName;
    }

    public exportToExcel(grid: ExportableGridComponent, onlySelected: boolean, columnDef: ColDef[], fileName?: string): void {
        this.busySubject.on();
        setTimeout(() => {
            try {
                const excelParams: ExcelExportParams = {
                    columnWidth: this.getColumnWidth(columnDef),
                    onlySelected
                };
                if (!!fileName) {
                    excelParams.fileName = fileName;
                }
                grid.exportGrid(excelParams);
            } finally {
                this.busySubject.off();
            }
        }, 0);
    }

    private getColumnWidth(columnDefs: ColDef[]): (params: ColumnWidthCallbackParams) => number {
        return (params: ColumnWidthCallbackParams) => {
            const excelColumnWidthFactor = 125;
            let columnWidth = 0;
            const colId = params.column?.getColId();
            const columnDef: ColDef | undefined = columnDefs.find((column) => column.field === colId);
            if (columnDef?.flex) {
                columnWidth = columnDef.flex * excelColumnWidthFactor;
            }
            return columnWidth;
        };
    }
}

interface ExportableGridComponent {
    exportGrid(excelParams: ExcelExportParams): void;
}
